import { Component, HostListener, OnInit, ViewChild } from '@angular/core';

import * as _ from 'lodash';

import { Attachment } from '../../models/attachment.model';

import { ModalComponent } from '../modal/modal.component';

import { SimpleDropdownDirective } from '../../directives/simple-dropdown.directive';

import { BodyFreezerService } from '../../services/body-freezer.service';
import { LightboxOption, LightboxService } from '../../services/lightbox.service';
import { ModalService } from '../../services/modal.service';

import { HelperUtil } from '../../utils/helper.util';

@Component({
  selector: 'gw-lightbox',
  exportAs: 'gwLightbox',
  templateUrl: './modal-lightbox.component.html',
  styleUrls: ['./modal-lightbox.component.scss']
})
export class ModalLightboxComponent extends ModalComponent implements OnInit {
  @ViewChild('dropdownMenu') dropdownMenu: SimpleDropdownDirective;
  /**
   * Image to preview in modal
   *
   * @required
   */
  currentImage: Attachment;
  /**
   * List of images to preview in modal
   */
  gallery: Array<Attachment>;
  /**
   * Index of current image in gallery
   *
   * @required
   */
  index: number;
  /**
   * Rotation of current image
   */
  rotation: number;
  /**
   * Options for images in modal
   */
  options: Array<LightboxOption>;

  constructor(
    public modalService: ModalService,
    protected bodyFreezer: BodyFreezerService,
    private lightboxService: LightboxService
  ) {
    super(modalService, bodyFreezer);
  }

  @HostListener('window:keydown', ['$event']) keyboardClick(event: KeyboardEvent): void {
    if (this.opened) {
      switch (event.key) {
        case 'Escape':
          this.close();
          break;
        case 'ArrowRight':
          this.goToNext();
          break;
        case 'ArrowLeft':
          this.goToPrevious();
          break;
      }
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  rotate(): { transform: string } {
    if (this.rotation && this.rotation !== 0 && !HelperUtil.isIOS()) {
      return {
        transform: `rotate(${this.rotation}deg)`
      };
    }
  }

  hasNext(): boolean {
    if (this.gallery) {
      this.index = _.findIndex(this.gallery, { checksum: this.currentImage.checksum });
      return this.gallery.length - 1 > this.index;
    }
    return false;
  }

  hasPrevious(): boolean {
    if (this.gallery) {
      this.index = _.findIndex(this.gallery, { checksum: this.currentImage.checksum });
      return this.index > 0;
    }
    return false;
  }

  goToNext(): void {
    if (this.index < this.gallery.length - 1) {
      this.currentImage = this.gallery[this.index + 1];
    }
  }

  goToPrevious(): void {
    if (this.index > 0) {
      this.currentImage = this.gallery[this.index - 1];
    }
  }

  blindClick(): void {
    this.close();
  }

  elementClick(event: MouseEvent): void {
    event.stopPropagation();
    if (this.dropdownMenu && this.dropdownMenu.opened) {
      this.dropdownMenu.closeDropdown();
    }
  }

  emitOption(option: LightboxOption): void {
    this.lightboxService.emitEvent({ option, attachment: this.currentImage });
  }
}
